import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {MercadoriasDefeitosModel} from "./mercadorias-defeitos.model";
import {MercadoriasDefeitosService} from './mercadorias-defeitos.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {MercadoriasService} from "../mercadorias/mercadorias.service";
import {UnidadesMedidasService} from '../unidades-medidas/unidades-medidas.service';

@Component({
  selector: 'app-mercadorias-defeitos-form',
  templateUrl: './mercadorias-defeitos-form.component.html'
})
export class MercadoriasDefeitosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  defeito: MercadoriasDefeitosModel = new MercadoriasDefeitosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;
  listMercadorias = [];
  listDefeitos = [];
  listIndicesAcumulados = [];
  listUnidadesMedidas = [];
  carregandoTabelaDefeitos = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private mercadoriasDefeitosService: MercadoriasDefeitosService,
    private mercadoriasService: MercadoriasService,
    private unidadesMedidasService: UnidadesMedidasService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      id_mercadoria: ['', [
        Validators.required,
        BasicValidators.diferenteZero
      ]],
      id_unidade_medida: ['', [
        Validators.required,
        BasicValidators.diferenteZero
      ]],
      nome_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_en: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      nome_es: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      descricao_pt: [],
      descricao_en: [],
      descricao_es: [],
      observacao_pt: [],
      observacao_en: [],
      observacao_es: [],
      is_indice_acumulado: [],
      ordem: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop().substring(0,3) == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop().substring(0,3) == 'add'){
      this.pageIsAdd = true;
    }

    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;

          if(this.global.debug == true){
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.unidadesMedidasService.get()
      .subscribe(
        json => {
          this.listUnidadesMedidas = [];
          for(let i in json.Payload){
            this.listUnidadesMedidas.push({
              id_unidade: json.Payload[i].id_unidade,
              nome: json.Payload[i].nome+' ('+ json.Payload[i].sigla+')'
            });
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.route.params.subscribe(params => {
      let id = params['id_defeito'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarDefeito');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarDefeito') : this.func.traduzir('front.cadastrarNovoDefeito');
      }

      if (!id) {
        if(this.route.snapshot.queryParams["mercadoria"]){
          this.defeito.id_mercadoria = this.route.snapshot.queryParams["mercadoria"];
          this.changeMercadoria(this.defeito.id_mercadoria);
        }
        return;
      }

      this.mercadoriasDefeitosService.getById(id, ['indices_acumulados'])
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarDefeito')+': '+json.Payload[0].nome_pt;
            }else{
              this.title = this.func.traduzir('front.visualizarDefeito') + ': ' + json.Payload[0].nome_pt;
            }
            this.defeito = json.Payload[0];

            this.changeMercadoria(this.defeito.id_mercadoria);

            for(let z in this.defeito['indices_acumulados']){
              this.listIndicesAcumulados.push(this.defeito['indices_acumulados'][z].id_defeito_indice);
            }

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
    values = this.form.value;

    values['indices_acumulados'] = (this.defeito.is_indice_acumulado) ? this.listIndicesAcumulados : [];

    if(values.is_indice_acumulado && this.listIndicesAcumulados.length == 0){
      values.is_indice_acumulado = false;
    }

    if (values.id) {
      result = this.mercadoriasDefeitosService.editar(values, values.id);
    } else {
      result = this.mercadoriasDefeitosService.adicionar(values);
    }

    result.subscribe(data => {
        if(this.route.snapshot.queryParams["mercadoria"]){
          this.router.navigate(['/painel', 'mercadorias', this.route.snapshot.queryParams["mercadoria"], 'upd'], { queryParams: { abadefeitos: '1' }});
        }else{
          this.router.navigate(['/painel', 'mercadorias', 'defeitos']);
        }
      },
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        for(let i in json.Message.ErrorInput){
          let erro = {};
          erro[i] = json.Message.ErrorInput[i];
          this.form.controls[i].setErrors(erro);
        }
      });
  }

  changeMercadoria(e){
    this.carregandoTabelaDefeitos = true;
    this.listIndicesAcumulados = [];

    this.mercadoriasDefeitosService.get(null, {"id_mercadoria": e})
      .subscribe(
        json => {
          this.listDefeitos = json.Payload;
          this.carregandoTabelaDefeitos = false;

          if(this.global.debug == true){
            console.log(json.Payload[0]);
          }
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  changeSelectDefeitos(id_defeito, event){
    console.log(id_defeito, event);

    if(event.srcElement.checked){
      this.listIndicesAcumulados.push(event.target.value);
    }else{
      this.listIndicesAcumulados = this.listIndicesAcumulados.filter(item => item !== event.target.value);
    }

    console.log('listIndicesAcumulados', this.listIndicesAcumulados);
  }

}



// WEBPACK FOOTER //
// ./src/app/mercadorias-defeitos/mercadorias-defeitos-form.component.ts